import styled from 'styled-components';
import { getColor, styleVariables } from '@lib/common';
export var Dashboard = styled.div.withConfig({
  displayName: "class-dashboardstyles__Dashboard",
  componentId: "sc-1rwg67c-0"
})(["display:flex;flex-direction:column;gap:20px;padding-bottom:24px;"]);
export var Panel = styled.section.withConfig({
  displayName: "class-dashboardstyles__Panel",
  componentId: "sc-1rwg67c-1"
})(["min-width:0;background:", ";border:1px solid #e6edf5;border-radius:12px;padding:20px;box-shadow:0 1px 3px rgba(0,0,0,0.03);"], styleVariables.colors.gray1);
export var Columns = styled.div.withConfig({
  displayName: "class-dashboardstyles__Columns",
  componentId: "sc-1rwg67c-2"
})(["display:grid;grid-template-columns:minmax(0,3fr) minmax(0,2fr);gap:20px;align-items:start;@media (max-width:1050px){grid-template-columns:minmax(0,1fr);}"]);
export var Header = styled.div.withConfig({
  displayName: "class-dashboardstyles__Header",
  componentId: "sc-1rwg67c-3"
})(["display:flex;justify-content:space-between;align-items:flex-start;gap:12px;margin-bottom:20px;h3{margin:0 0 4px;font-size:18px;font-weight:700;color:#101828;}p{margin:0;color:#718096;font-size:14px;}"]);
export var Overview = styled(Panel).withConfig({
  displayName: "class-dashboardstyles__Overview",
  componentId: "sc-1rwg67c-4"
})([".overview-metrics{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:16px;}@media (max-width:1000px){.overview-metrics{grid-template-columns:repeat(3,minmax(0,1fr));}}@media (max-width:600px){.overview-metrics{grid-template-columns:repeat(2,minmax(0,1fr));}}"]);
export var Metric = styled.div.withConfig({
  displayName: "class-dashboardstyles__Metric",
  componentId: "sc-1rwg67c-5"
})(["min-width:0;padding:16px;border-radius:12px;background:", ";border:1px solid ", ";.ant-statistic{display:flex;flex-direction:column-reverse;}.ant-statistic-content{font-size:26px;font-weight:700;color:", ";}.ant-statistic-title{margin-bottom:0;color:", ";}"], getColor('fillBgWhite'), getColor('fillIntSubActive'), getColor('fillIntActive'), getColor('contentBody'));
export var AssignmentRows = styled.div.withConfig({
  displayName: "class-dashboardstyles__AssignmentRows",
  componentId: "sc-1rwg67c-6"
})(["display:flex;flex-direction:column;gap:10px;margin-top:16px;"]);
export var AssignmentRow = styled.article.withConfig({
  displayName: "class-dashboardstyles__AssignmentRow",
  componentId: "sc-1rwg67c-7"
})(["display:flex;gap:12px;align-items:center;padding:14px;border:1px solid #e6edf5;border-radius:10px;min-width:0;.assignment-main{flex:1;min-width:0;}.assignment-title{display:flex;flex-wrap:wrap;align-items:center;gap:8px;}.assignment-title strong{overflow-wrap:anywhere;}.assignment-meta{margin-top:6px;color:#718096;font-size:13px;}.assignment-status{width:150px;flex-shrink:0;}.assignment-timing{display:flex;flex-wrap:wrap;gap:6px 16px;}.assignment-submission{flex-shrink:0;font-size:13px;.ant-tag{margin-right:0;}}@media (max-width:650px){flex-wrap:wrap;.assignment-main{flex:1 1 100%;}.assignment-status{width:auto;margin-left:0;flex:1;}> button:last-child{margin-left:auto;}}"]);
export var AssignmentIcon = styled.div.withConfig({
  displayName: "class-dashboardstyles__AssignmentIcon",
  componentId: "sc-1rwg67c-8"
})(["flex-shrink:0;width:42px;height:48px;display:flex;align-items:center;justify-content:center;border-radius:10px;font-size:22px;color:", ";background:", ";"], function (_ref) {
  var $exam = _ref.$exam;
  return $exam ? '#fa8c16' : '#165dff';
}, function (_ref2) {
  var $exam = _ref2.$exam;
  return $exam ? '#fff7e8' : '#eef4ff';
});
export var Feed = styled.div.withConfig({
  displayName: "class-dashboardstyles__Feed",
  componentId: "sc-1rwg67c-9"
})(["max-height:", ";", " overflow-y:auto;overscroll-behavior:contain;display:flex;flex-direction:column;gap:", ";padding-right:4px;scrollbar-width:thin;"], function (_ref3) {
  var $full = _ref3.$full;
  return $full ? 'none' : '600px';
}, function (_ref4) {
  var $full = _ref4.$full;
  return $full && 'flex: 1; min-height: 0;';
}, function (_ref5) {
  var $full = _ref5.$full;
  return $full ? '20px' : '10px';
});
export var AnnouncementCard = styled.article.withConfig({
  displayName: "class-dashboardstyles__AnnouncementCard",
  componentId: "sc-1rwg67c-10"
})(["background:", ";border:1px solid #e6edf5;border-radius:10px;padding:", ";flex-shrink:0;font-size:", ";min-width:0;.announcement-author{display:flex;align-items:center;gap:10px;margin-bottom:12px;}.announcement-author-info{flex:1;min-width:0;}.announcement-author-info strong{display:block;}.announcement-author-info time{color:#718096;font-size:12px;}.announcement-title{font-size:", ";margin-bottom:10px;font-weight:600;}"], getColor('fillBgWhite'), function (_ref6) {
  var $full = _ref6.$full;
  return $full ? '24px' : '14px';
}, function (_ref7) {
  var $full = _ref7.$full;
  return $full ? '16px' : '14px';
}, function (_ref8) {
  var $full = _ref8.$full;
  return $full ? '20px' : '16px';
});
export var RichContent = styled.div.withConfig({
  displayName: "class-dashboardstyles__RichContent",
  componentId: "sc-1rwg67c-11"
})(["color:#344054;line-height:1.6;overflow-wrap:anywhere;overflow-x:auto;", " p:last-child{margin-bottom:0;}ul,ol{padding-left:24px;}img{max-width:100%;height:auto;}table{border-collapse:collapse;width:100%;}td,th{border:1px solid #d0d5dd;padding:8px;min-width:60px;}th{background:#f8fafc;}blockquote{border-left:3px solid #c7d7ff;padding-left:12px;margin-left:0;}"], function (_ref9) {
  var $preview = _ref9.$preview;
  return $preview && 'max-height: 180px; overflow: hidden;';
});
export var Composer = styled.div.withConfig({
  displayName: "class-dashboardstyles__Composer",
  componentId: "sc-1rwg67c-12"
})(["display:flex;flex-direction:column;gap:16px;.ant-form-item:last-child{margin-bottom:0;}.tiptap{min-height:240px;max-height:420px;overflow-y:auto;}"]);
export var ReferenceCard = styled.div.withConfig({
  displayName: "class-dashboardstyles__ReferenceCard",
  componentId: "sc-1rwg67c-13"
})(["display:flex;align-items:center;gap:12px;padding:12px;margin-top:12px;border:1px solid #dbe7ff;border-radius:10px;background:#f4f8ff;min-width:0;.reference-information{flex:1;min-width:0;overflow-wrap:anywhere;}strong{display:block;margin-bottom:6px;}p{margin:6px 0 0;color:#718096;font-size:13px;}@media (max-width:500px){flex-wrap:wrap;> a:last-child{margin-left:auto;}}"]);